import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const AddPurchase = () => {
  const [items, setItems] = useState([
    {
      id: Date.now(),
      category: "",
      name: "",
      stock_name: "",
      items_name: "",
      quantity: "",
      unit: "",
      total: "",
    },
  ]);
const [errors, setErrors] = useState({});

  const [user_id, setUserId] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [invoice, setInvoice] = useState("");
  const [date, setDate] = useState("");
  const [purchaseBy, setPurchaseBy] = useState("");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryItems, setCategoryItems] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const userid = localStorage.getItem("user_id");
    if (userid) setUserId(userid);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [vendorRes, categoryRes] = await Promise.all([
          axios.get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/"),
          axios.get("https://ims-backend.indevconsultancy.in/admin-panel/category/"),
        ]);
        setVendors(vendorRes.data);
        setCategories(categoryRes.data);
      } catch (err) {
        console.error("Error fetching vendors/categories:", err);
      }
    };
    fetchData();
  }, []);

  const fetchItemsByCategory = async (categoryId, rowId) => {
    if (!categoryId) return;
    try {
      const res = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/itemlist/?categoryid=${categoryId}&kitchenid=19`
      );
      setCategoryItems((prev) => ({
        ...prev,
        [rowId]: res.data,
      }));
    } catch (err) {
      console.error(`Error fetching items for row ${rowId}:`, err);
    }
  };

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        id: Date.now(),
        category: "",
        name: "",
        stock_name: "",
        items_name: "",
        quantity: "",
        unit: "",
        total: "",
      },
    ]);
  };

  const handleRemoveItem = (id) => {
    if (items.length > 1) {
      setItems(items.filter((item) => item.id !== id));
    }
  };

  const handleItemChange = (id, field, value) => {
 setItems((prev) =>
    prev.map((item) =>
      item.id === id
        ? {
            ...item,
            [field]: value,
            total:
              field === "quantity" || field === "unit"
                ? (field === "quantity"
                    ? parseFloat(value || 0) * parseFloat(item.unit || 0)
                    : parseFloat(item.quantity || 0) * parseFloat(value || 0)) || ""
                : item.total,
          }
        : item
    )
  ); 
  };

  const handleReset = () => {
    setVendor("");
    setInvoice("");
    setDate("");
    setPurchaseBy("");
    setItems([
      {
        id: Date.now(),
        category: "",
        name: "",
        stock_name: "",
        items_name: "",
        quantity: "",
        unit: "",
        total: "",
      },
    ]);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  const handleSubmit = async (e) => {
  e.preventDefault();

  let newErrors = {};

  // 🔹 Form-level validations
  if (!vendor) newErrors.vendor = true;
  if (!invoice) newErrors.invoice = true;
  if (!date) newErrors.date = true;
  if (!purchaseBy) newErrors.purchaseBy = true;

  // 🔹 Items-level validations
  items.forEach((item, index) => {
    if (!item.category) newErrors[`category_${index}`] = true;
    if (!item.name) newErrors[`name_${index}`] = true;
    if (!item.quantity) newErrors[`quantity_${index}`] = true;
    if (!item.unit) newErrors[`unit_${index}`] = true;
    if (!item.total) newErrors[`total_${index}`] = true;
  });

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    return; // ❌ Stop submit if errors exist
  }

  setLoading(true);

  // 🔹 Random purchase ID
  const purchaseId = Math.floor(10000000 + Math.random() * 90000000);

  // 🔹 Payload for API
  const payload = {
    user_id: user_id,
    parchase_id: purchaseId,
    invoice_no: invoice,
    date: date,
    parchase_by: purchaseBy,
    created_at: new Date().toISOString(),
    status: 1,
    del_action: "N",
    vendor: vendor,
    items: items.map((item) => ({
      parchase_id: purchaseId,
      category_id: item.category,
      items_id: item.name,
      stock_name: item.stock_name,
      items_name: item.items_name,
      quantity: item.quantity,
      unit: item.unit,
      total_amount: item.total,
    })),
  };

  try {
    const res = await axios.post(
      "https://ims-backend.indevconsultancy.in/admin-panel/purchase/create/",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    console.log("API Response:", res.data);
    alert("Purchase added successfully!");
    navigate("/purchasePO");

  } catch (err) {
    console.error("Error adding purchase:", err);
    alert("Failed to add purchase.");
  } finally {
    setLoading(false);
  }
};

//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   let newErrors = {};

//   if (!vendor) newErrors.vendor = true;
//   if (!invoice) newErrors.invoice = true;
//   if (!date) newErrors.date = true;
//   if (!purchaseBy) newErrors.purchaseBy = true;

//   items.forEach((item, index) => {
//     if (!item.category) newErrors[`category_${index}`] = true;
//     if (!item.name) newErrors[`name_${index}`] = true;
//     if (!item.quantity) newErrors[`quantity_${index}`] = true;
//     if (!item.unit) newErrors[`unit_${index}`] = true;
//     if (!item.total) newErrors[`total_${index}`] = true;
//   });

//   setErrors(newErrors);

//   if (Object.keys(newErrors).length > 0) {
//     return; // ❌ stop submit if errors exist
//   }

//   setLoading(true);

//   // ... baki tera API call wala code
// };


//     const purchaseId = Math.floor(10000000 + Math.random() * 90000000);

//     const payload = {
//       user_id: user_id,
//       parchase_id: purchaseId, // check spelling with backend
//       invoice_no: invoice,
//       date: date,
//       parchase_by: purchaseBy, // check spelling with backend
//       created_at: new Date().toISOString(),
//       status: 1,
//       del_action: "N",
//       vendor: vendor,
//       items: items.map((item) => ({
//         parchase_id: purchaseId,
//         category_id: item.category,
//         items_id: item.name,
//         stock_name: item.stock_name,
//         items_name: item.items_name,
//         quantity: item.quantity,
//         unit: item.unit,
//         total_amount: item.total,
//       })),
//     };

//     try {
//       const res = await axios.post(
//         "https://ims-backend.indevconsultancy.in/admin-panel/purchase/create/",
//         payload,
//         { headers: { "Content-Type": "application/json" } }
//       );
//       console.log("API Response:", res.data);
//       alert("Purchase added successfully!");
//       navigate("/purchasePO");
//     } catch (err) {
//       console.error("Error adding purchase:", err);
//       alert("Failed to add purchase.");
//     } finally {
//       setLoading(false);
//     }
//   };

  // 🔹 Calculate grand total
  const grandTotal = items.reduce((sum, item) => sum + (Number(item.total) || 0), 0);

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-md-6 text-start">
          <h5>Add Purchase</h5>
        </div>
        <div className="col-md-6 text-end">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-end mb-0">
              <li className="breadcrumb-item active" aria-current="page">
                Add Expenditure
              </li>
              <li className="breadcrumb-item">
                <Link to="/purchasePO">List Purchase Items</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">Add Purchase</h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3 row">
              <div className="col-6">
                <label className="form-label">Vendor Name</label>
                <select
                  className="form-select"
                  value={vendor}
                  onChange={(e) => setVendor(e.target.value)}
                >
                  <option value="">Select Vendor</option>
                  {vendors.map((v) => (
                    <option key={v.vendor_id} value={v.vendor_id}>
                      {v.vendor_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <label className="form-label">Invoice No.</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Invoice No."
                  value={invoice}
                  onChange={(e) => setInvoice(e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-6">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div className="col-6">
                <label className="form-label">Purchase By</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Purchase By"
                  value={purchaseBy}
                  onChange={(e) => setPurchaseBy(e.target.value)}
                />
              </div>
            </div>

            {items.map((item) => (
              <div key={item.id} className="row g-2 mb-3 align-items-end">
                <div className="col-md-2">
                  <label className="form-label">Category</label>
                  <select
                    className="form-control"
                    value={item.category || ""}
                    onChange={(e) => {
                      const categoryId = e.target.value;
                      handleItemChange(item.id, "category", categoryId);
                      fetchItemsByCategory(categoryId, item.id);
                    }}
                  >
                    <option value="">Select Category</option>
                    {categories.map((c) => (
                      <option key={c.category_id} value={c.category_id}>
                        {c.category_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Item</label>
                  <select
                    className="form-control"
                    value={item.name || ""}
                    onChange={(e) => {
                      const selectedId = Number(e.target.value);
                      const selectedItem = categoryItems[item.id]?.find(
                        (it) => it.stock_id === selectedId
                      );
                      const unitPrice = selectedItem?.price || "";
                      const qty = item.quantity || 0;

                      handleItemChange(item.id, "name", selectedId);
                      handleItemChange(item.id, "stock_name", selectedItem?.stock_name || "");
                      handleItemChange(item.id, "items_name", selectedItem?.items_name || "");
                      handleItemChange(item.id, "unit", unitPrice);
                      handleItemChange(item.id, "total", qty * unitPrice);
                    }}
                  >
                    <option value="">Select Item</option>
                    {categoryItems[item.id]?.map((it) => (
                      <option key={it.stock_id} value={it.stock_id}>
                        {it.items_name || it.stock_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Quantity</label>
                  <div className="input-group">
                    <input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      className="form-control"
                      placeholder="Quantity"
                      value={item.quantity}
                      onChange={(e) => {
                        const qty = parseFloat(e.target.value);
                        handleItemChange(item.id, "quantity", qty);
                        handleItemChange(item.id, "total", qty * item.unit);
                      }}
                    />
                    <span className="input-group-text">kg</span>
                  </div>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Unit Price</label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="form-control"
                    placeholder="Unit"
                    value={item.unit}
                    onChange={(e) => {
                      const unitPrice = parseFloat(e.target.value);
                      handleItemChange(item.id, "unit", unitPrice);
                      handleItemChange(item.id, "total", item.quantity * unitPrice);
                    }}
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label">Total</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Total"
                    value={item.total}
                    readOnly
                  />
                </div>

                <div className="col-md-1">
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={handleAddItem}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                <div className="col-md-1">
                  <button
                    className="btn btn-danger w-100"
                    type="button"
                    onClick={() => handleRemoveItem(item.id)}
                    disabled={items.length === 1}
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                </div>
              </div>
            ))}
            <div className="text-end">
              <h4>Total Price: {grandTotal}</h4>
            </div>

            <div className="text-end">
              <button
                className="btn btn-secondary me-2"
                type="button"
                onClick={handleReset}
              >
                Clear
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPurchase;
